import React from "react";
import moment from "moment";
import { ConnectedAccountProfile } from "../Accounts/AccountProfile";
import { FormattedMessage } from "react-intl";

const UpdatedBy = ({ updater, updateDate }) => {
  if (!updater || !updateDate) return null;

  return (
    <div className="w-100">
      <div className="mb-3 fs-14 fw-medium text-black">
        <FormattedMessage id={"UPDATED_BY"} />
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <div className="fs-14 fw-medium text-black">
          <ConnectedAccountProfile account={updater} />
        </div>
        <div className="text-black">
          <span className="fs-12 ml-1">
            {moment(updateDate).format("DD/MM/YYYY HH:mm")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default UpdatedBy;
